var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticClass: "de-filter-data-table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.starData,
            "show-header": false,
            "highlight-current-row": true,
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "name", label: _vm.$t("commons.name") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "start-item" }, [
                      _c(
                        "div",
                        {
                          staticClass: "filter-db-row star-item-content",
                          staticStyle: {
                            "white-space": "nowrap",
                            overflow: "hidden",
                            "text-overflow": "ellipsis",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showPanel(scope.row)
                            },
                          },
                        },
                        [
                          _c("svg-icon", {
                            staticClass: "ds-icon-scene",
                            attrs: {
                              "icon-class": "panel-" + scope.row.status,
                            },
                          }),
                          _c("span", { class: scope.row.status }, [
                            _vm._v(" " + _vm._s(scope.row.name)),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "star-item-close" }, [
                        _c("i", {
                          staticClass: "el-icon-delete ",
                          on: {
                            click: function ($event) {
                              return _vm.remove(scope.row)
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }